import { MenuItem } from "@openng/optimus-ui/api";
import { Arrays } from "src/modules/utils/shared/arrays";
import { Objects } from "src/modules/utils/shared/objects";
import { GeneralObjectKey } from "../netgen/GeneralObjectKey";
import { GeneralObjectActionProvider } from "./general-object-action-provider.model";
import { ObjectActionWithObject } from "./object-action-with-object.model";
import { ObjectAction } from "./object-action.model";

export class ObjectActionRegistry {

    private static globalActionGroups = new Map<string, ObjectAction[]>();

    static registerGlobalActions(id: string, actions: ObjectAction[]): void {
        this.globalActionGroups.set(id, actions);
    }

    static getGlobalActions(value: any): ObjectActionWithObject[] {
        return this.getGlobalActionDefinitions(value).map(action => new ObjectActionWithObject(action, value));
    }

    static getGlobalActionDefinitions(value: any): ObjectAction[] {
        return Arrays.explode(Array.from(this.globalActionGroups.values()), actions => actions.filter(action => action.isUsable(value)));
    }

    static getSemanticActions(keys: GeneralObjectKey[], providers: GeneralObjectActionProvider[]): ObjectActionWithObject[] {
        return [
            ...Arrays.explode(providers, provider => Arrays.explode(keys, key => provider.getActions(key).filter(action => action.isUsable(key)).map(action => new ObjectActionWithObject(action, key)))),
            ...Arrays.explode(keys, key => Arrays.explode(Array.from(this.globalActionGroups.values()), actions => actions.filter(action => action.generalObjectTypes?.includes(key.type) && action.isUsable(key)).map(action => new ObjectActionWithObject(action, key))))
        ];
    }

    static getSemanticActionMenuItems(actions: ObjectActionWithObject[]): MenuItem[] {
        let result: MenuItem[] = [];
        let groups = new Map<string, ObjectActionWithObject[]>();
        for (let action of actions) {
            let key = action.on as GeneralObjectKey;
            let groupId = key.type + "\n" + action.getCaption() + "\n" + action.getIcon();
            groups.set(groupId, [...groups.get(groupId) ?? [], action]);
        }
        for (let group of groups.values()) {
            let first = group[0];
            let items: MenuItem[] = group.map((action, index) => this.toMenuItem(action, this.getReferenceCaption(action.on as GeneralObjectKey, index)));
            if (first.action.performMultiple != null) {
                items = [{
                    label: "Alle " + group.length + " Objekte",
                    icon: first.getIcon(),
                    command: () => first.action.performMultiple(group.map(action => action.on))
                }, { separator: true }, ...items];
            }
            result.push(group.length == 1 ? this.toMenuItem(first) : {
                label: first.getCaption() + " (" + group.length + " Objekte)",
                icon: first.getIcon(),
                items
            });
        }
        return result;
    }

    private static toMenuItem(action: ObjectActionWithObject, caption = action.getCaption()): MenuItem {
        return {
            label: caption,
            icon: action.getIcon(),
            command: () => action.perform()
        };
    }

    private static getReferenceCaption(value: GeneralObjectKey, index: number): string {
        let id = value.key?.id;
        if (id != null) {
            return (value.type == "enaio.object" ? "Objekt-ID " : "ID ") + Objects.toString(id);
        }
        let fileName = Objects.toString(value.key?.fileName);
        if (fileName != "") {
            return fileName + (value.key?.lineNumber == null ? "" : ":" + Objects.toString(value.key.lineNumber));
        }
        let name = Objects.toString(value.key?.name ?? value.key?.title);
        return name == "" ? "Objekt " + (index + 1) : name;
    }
}
